.idPhotoPanel {
	display: flex;
	gap: 10px;
	height: 100%;
	justify-content: space-evenly;
	border-radius: 8px;
	background-color: #1c1d22;
	width: 100%;
	padding-top: 3vh;
}

.idPhotoContainer {
	display: flex;
	flex-direction: column;
	height: 100%;
	gap: 13%;
	width: 45%;
}

.idPhotoImage {
	max-width: 100%;
	max-height: 65%;
	object-fit: contain;
}
